/* TALINA BEACH GOIANIA - promocao Yever: 2 pecas da loja, 1 bolsa.
   A Shopify pode mostrar valor no carrinho; gratuidade depende do checkout Yever. */
(function () {
  'use strict';
  var node = document.getElementById('talina-bolsa-config');
  var cfg;
  try { cfg = JSON.parse(node && node.textContent || '{}'); } catch (e) { return; }
  if (!cfg.enabled) return;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  if (root.charAt(root.length - 1) !== '/') root += '/';
  var giftVariant = Number(cfg.variantId);
  var giftProduct = Number(cfg.productId);
  if (!giftVariant || !giftProduct) return;
  var busy = false, timer = null, lastSignature = '';
  var dismissedKey = 'talina_bolsa_dispensada';
  var previousEligible = null;
  try {
    var lastSaved = sessionStorage.getItem('talina_bolsa_ultima_qtd');
    if (lastSaved !== null && Number.isFinite(Number(lastSaved))) previousEligible = Number(lastSaved);
  } catch (e) {}
  function rememberEligible(qty) {
    previousEligible = qty;
    try { sessionStorage.setItem('talina_bolsa_ultima_qtd', String(qty)); } catch (e) {}
  }

  // Celebração visual incorporada ao aviso do carrinho lateral; sem pop-up flutuante.

  function dismissed() { try { return sessionStorage.getItem(dismissedKey) === '1'; } catch (e) { return false; } }
  function setDismissed(value) { try { if (value) sessionStorage.setItem(dismissedKey, '1'); else sessionStorage.removeItem(dismissedKey); } catch (e) {} }
  async function api(path, opts) {
    var res = await fetch(root + path, Object.assign({
      credentials: 'same-origin', cache: 'no-store',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' }
    }, opts || {}));
    if (!res.ok) throw new Error(path + ': ' + res.status);
    return res.json();
  }
  function eligibleCount(cart) {
    return (cart.items || []).reduce(function (sum, item) {
      return sum + (Number(item.product_id) === giftProduct ? 0 : Number(item.quantity || 0));
    }, 0);
  }
  function giftLines(cart) {
    return (cart.items || []).filter(function (item) {
      return Number(item.variant_id) === giftVariant &&
        item.properties && String(item.properties._brinde_talina || '') === '1';
    });
  }
  function anyGift(cart) {
    return (cart.items || []).some(function (item) { return Number(item.product_id) === giftProduct; });
  }
  function sig(cart) {
    return (cart.items || []).map(function (i) {
      return i.key + ':' + i.quantity + ':' + i.final_line_price;
    }).join('|');
  }
  async function change(line, quantity) {
    return api('cart/change.js', { method: 'POST', body: JSON.stringify({ id: line.key, quantity: quantity }) });
  }
  function notify(cart) {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
      detail: { cart: cart }, bubbles: true
    }));
  }
  async function sync() {
    if (busy) return;
    busy = true;
    try {
      var cart = await api('cart.js');
      var qty = eligibleCount(cart);
      var tagged = giftLines(cart), changed = false;
      if (qty < 2) {
        setDismissed(false);
        for (var remove of tagged) { await change(remove, 0); changed = true; }
      } else if (tagged.length) {
        if (tagged[0].quantity !== 1) { await change(tagged[0], 1); changed = true; }
        for (var extra of tagged.slice(1)) { await change(extra, 0); changed = true; }
      } else if (!dismissed() && !anyGift(cart)) {
        await api('cart/add.js', {
          method: 'POST',
          body: JSON.stringify({ items: [{ id: giftVariant, quantity: 1, properties: { _brinde_talina: '1' } }] })
        });
        changed = true;
      }
      if (changed) cart = await api('cart.js');
      var confirmedCount = eligibleCount(cart);
      rememberEligible(confirmedCount);
      var next = sig(cart);
      if (changed || (lastSignature && next !== lastSignature)) {
        notify(cart);
        if (document.body && document.body.classList.contains('template-cart')) window.location.reload();
      }
      lastSignature = next;
    } catch (e) { console.warn('[Bolsa Talina - tema Goiania]', e); }
    finally { busy = false; }
  }
  function schedule(delay) { clearTimeout(timer); timer = setTimeout(sync, delay === undefined ? 350 : delay); }
  document.addEventListener('click', function (e) {
    if (e.target.closest('.talina-bolsa-brinde-linha .line-item__remove-button')) setDismissed(true);
    if (e.target.closest('[name="add"],[data-add-to-cart],cart-drawer button,cart-drawer a')) schedule(900);
  }, true);
  document.addEventListener('change', function (e) {
    if (e.target.closest('form[action*="/cart"],cart-drawer,[data-cart]')) schedule(850);
  }, true);
  ['cart:updated', 'cart:change', 'cart:refresh'].forEach(function (name) {
    document.addEventListener(name, function () { schedule(550); });
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { schedule(100); }, { once: true });
  } else schedule(100);
}());
